import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;
// Label
export const getLabelTpl = (payload) => {
  return axios
    .get(`${URL_ORI}/api/labelTpl/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getIdLabelTpl = (id) => {
  return axios
    .get(`${URL_ORI}/api/labelTpl/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createLabelTpl = (payload) => {
  return axios.post(`${URL_ORI}/api/labelTpl`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateLabelTpl = (payload) => {
  return axios.put(`${URL_ORI}/api/labelTpl`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteLabelTpl = (payload) => {
  return axios.delete(`${URL_ORI}/api/labelTpl`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const postFile = (file_type, object_id, file) => {
  console.log(file_type, object_id, file, "asd");
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/file/uploadfile?file_type=${file_type}&object_id=${object_id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// area Type

export const getMstareatype = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Mstareatype/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getIdMstareatype = (id) => {
  return axios
    .get(`${URL_ORI}/api/Mstareatype/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createMstareatype = (payload) => {
  return axios.post(`${URL_ORI}/api/Mstareatype`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateMstareatype = (payload) => {
  return axios.put(`${URL_ORI}/api/Mstareatype`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteMstareatype = (payload) => {
  return axios.delete(`${URL_ORI}/api/Mstareatype`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

// Mstinspectcat

export const getMstinspectcat = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Mstinspectcat/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getIdMstinspectcat = (id) => {
  return axios
    .get(`${URL_ORI}/api/Mstinspectcat/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createMstinspectcat = (payload) => {
  return axios.post(`${URL_ORI}/api/Mstinspectcat`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateMstinspectcat = (payload) => {
  return axios.put(`${URL_ORI}/api/Mstinspectcat`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteMstinspectcat = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Mstinspectcat`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Mstdamagecond

export const getMstdamagecond = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Mstdamagecond/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getIdMstdamagecond = (id) => {
  return axios
    .get(`${URL_ORI}/api/Mstdamagecond/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createMstdamagecond = (payload) => {
  return axios.post(`${URL_ORI}/api/Mstdamagecond`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateMstdamagecond = (payload) => {
  return axios.put(`${URL_ORI}/api/Mstdamagecond`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteMstdamagecond = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Mstdamagecond`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Preferences

export const getPreferences = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Preferences/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getIdPreferences = (id) => {
  return axios
    .get(`${URL_ORI}/api/Preferences/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createPreferences = (payload) => {
  return axios.post(`${URL_ORI}/api/Preferences`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updatePreferences = (payload) => {
  return axios.put(`${URL_ORI}/api/Preferences`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deletePreferences = (payload) => {
  return axios.delete(`${URL_ORI}/api/Preferences`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
